(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["amicoda-details"] && !Shopify.designMode) return;
  try {
    (function () {
    document
      .querySelectorAll("[data-virelle-accordion]")
      .forEach(function (accordion) {
        const items = Array.from(
          accordion.querySelectorAll("details")
        );

        if (!items.length) return;

        
        if (!items.some(function (item) {
          return item.open;
        })) {
          items[0].open = true;
        }

        items.forEach(function (item) {
          const summary = item.querySelector("summary");

          if (!summary || summary.dataset.locked === "true") return;
          summary.dataset.locked = "true";

          
          summary.addEventListener("click", function (event) {
            if (item.open) {
              event.preventDefault();
            }
          });

          
          item.addEventListener("toggle", function () {
            if (!item.open) return;

            items.forEach(function (otherItem) {
              if (otherItem !== item) {
                otherItem.open = false;
              }
            });
          });
        });
      });
  })();
  } catch(e) { console.error(e); }
})();

})();
